import { render, staticRenderFns } from "./pourquoi-faire-appel-a-une-agence-facebook-ads-pour-booster-vos-campagnes-publicitaires.vue?vue&type=template&id=5079e80a&"
import script from "./pourquoi-faire-appel-a-une-agence-facebook-ads-pour-booster-vos-campagnes-publicitaires.vue?vue&type=script&lang=js&"
export * from "./pourquoi-faire-appel-a-une-agence-facebook-ads-pour-booster-vos-campagnes-publicitaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports